import { List } from 'immutable';
import { sortStrings, oldestFirstSorter } from 'flow/utils/sorter-utils';
import {
    filterChannelsByMember,
    filterQueuesByMember,
} from 'flow/utils/pbx-utils';

export const sortChannels = (channels, chatUserKey) => {
    if (!channels) {
        return List();
    }

    const myChannels = filterChannelsByMember(channels, chatUserKey);
    const otherChannels = channels.filter(
        (channel) => !myChannels.includes(channel),
    );

    return myChannels
        .sort(channelSorter)
        .concat(otherChannels.sort(channelSorter));
};

const channelSorter = (channel1, channel2) => {
    const string1 = channel1 ? channel1.get('channelName') : null;
    const string2 = channel2 ? channel2.get('channelName') : null;
    return sortStrings(string1, string2);
};

export const sortQueues = (queues, allQueueMembers, extensionKey) => {
    if (!queues) {
        return List();
    }
    const myQueues = filterQueuesByMember(
        queues,
        allQueueMembers,
        extensionKey,
    );
    const otherQueues = queues.filter((queue) => !myQueues.includes(queue));

    return sortPbxServices(myQueues).concat(sortPbxServices(otherQueues));
};

export const sortPbxServices = (service) => {
    if (!service) {
        return List();
    }
    return service.sort(pbxServiceSorter);
};

const pbxServiceSorter = (pbxService1, pbxService2) => {
    const string1 = pbxService1 ? pbxService1.get('description') : null;
    const string2 = pbxService2 ? pbxService2.get('description') : null;

    return sortStrings(string1, string2);
};

export const sortQueueItems = (queueItem) => {
    if (!queueItem) {
        return List();
    }
    return queueItem.sort(queueItemsSorter);
};

const queueItemsSorter = (queueItem1, queueItem2) => {
    const joinTime1 = queueItem1 ? queueItem1.get('joinTime') : null;
    const joinTime2 = queueItem2 ? queueItem2.get('joinTime') : null;

    return oldestFirstSorter(joinTime1, joinTime2);
};
